module.exports = __webpack_public_path__ + "static/media/ck.1f276131.jpeg";